import { api } from '../commonApi';
import { ICreateRestaurantRequest, IGetRestaurantResponse } from '../../proto/restaurant/restaurant';

const BASE_RESTAURANT_URL = `/restaurant`;

export const restaurantApi = api.injectEndpoints({
	endpoints: (builder) => ({
		updateRestaurant: builder.mutation<void, ICreateRestaurantRequest & { id: string }>({
			query: ({ id, ...body }) => ({
				url: `${BASE_RESTAURANT_URL}/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: (result, error, { id }) => [{ type: 'Restaurant', id }],
		}),
		getRestaurantById: builder.query<IGetRestaurantResponse, string>({
			query: (id) => `${BASE_RESTAURANT_URL}/${id}`,
			providesTags: (result, error, id) => [{ type: 'Restaurant', id }],
		}),
	}),
});

export const { useLazyGetRestaurantByIdQuery, useGetRestaurantByIdQuery, useUpdateRestaurantMutation } = restaurantApi;
